import { render } from "./TableDefault.vue?vue&type=template&id=7d8f8cc2&scoped=true"
import script from "./TableDefault.vue?vue&type=script&lang=js"
export * from "./TableDefault.vue?vue&type=script&lang=js"

import "./TableDefault.vue?vue&type=style&index=0&id=7d8f8cc2&lang=scss&scoped=true"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8f8cc2"]])

export default __exports__